








































































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import ModalBatalSoap from "@/components/modal/ModalBatalSoap.vue";
import { appModule } from "@/store/modules/app";
import moment from "moment";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import MonitorTandaVitalChart from "@/components/chart/MonitorTandaVitalChart.vue";
import CpptRanapStore from "@/store/modules/CpptRanapStore";
import Handover from "@/services/Handover";
import PerawatAutoComplete from "@/components/pemeriksaan/assesmen/PerawatAutoComplete.vue";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";

@Component({
  components: {
    ModalBatalSoap,
    MonitorTandaVitalChart,
    PerawatAutoComplete,
    PersonAutoComplete,
    VCDateTimePicker
  }
})
export default class HandOverInput extends Vue {
  @Ref() readonly sub;
  @Prop({ default: false }) readonly readonly?: boolean;
  @Prop() value: {
    id: number;
    register_id: number;
    pasien_rm: string;
    unit_id: string;
    from_user_id: number;
    to_user_id: number;
    transferred_at: string;
    approved_at: string;
    verified_at: string;
  };
  @Prop({ default: false }) isActive?: boolean;

  isFormValid = true;
  validasi = [v => !!v || "*Kolom ini harus diisi"];

  id = null;
  from_user_id: number = null;
  to_user_id: number = null;
  to_user: object = null;
  transferred_at: Date = null;
  examinedAt: string | Date = null;
  verifiedAt: string | Date = null;

  removing = false;
  saving = false;

  showBatal = false;

  get user() {
    return userModule.user;
  }

  get dateTimeFieldProps() {
    return {
      outlined: true,
      dense: true,
      hint: this.isVerified
        ? "Waktu Pencatatan tidak bisa diubah bila sudah diverifikasi DPJP"
        : null,
      "persistent-hint": this.isVerified
    };
  }

  datetimeInput() {
    const dtime = new Date();
    if (this.transferred_at > dtime) {
      this.$nextTick(() => {
        this.transferred_at = null;

        appModule.sendErrorAlert(
          "Tanggal dan jam tidak dapat diinput melebihi <br/>" +
            moment().format("DD-MM-YYYY HH:mm")
        );
      });
    }
  }

  @Watch("value", {
    deep: true
  })
  changedValue(newVal, oldVal) {
    console.log("Handover val", newVal);
    if (!newVal) {
      console.log("clear input", newVal);
      this.clearInput();
    } else if (newVal != oldVal) {
      console.log("edit ho", newVal);
      // mode edit / copy soap
      this.id = newVal.id;
      this.from_user_id = Number.parseInt(newVal.from_user_id);
      this.to_user_id = Number.parseInt(newVal.to_user_id);
      this.transferred_at = newVal.transferred_at;
    }
  }

  get HandoverList() {
    return CpptRanapStore.handoverList.filter(soap => soap.unit_id >= "30");
  }

  get canEdit() {
    return this.isNakes && this.id;
  }

  get canMakeSoap() {
    return this.isNakes;
  }

  get isDokter() {
    return ["Dokter", "Psikolog"].includes(this.activeUser.profesi);
  }

  get isNonMedis() {
    return this.activeUser.profesi !== "Dokter" && this.isNakes;
  }

  get isNakes() {
    return this.activeUser.is_nakes;
  }

  get registerId(): number {
    return Number.parseInt(this.$route.params.register);
  }

  get pasienRm(): string {
    return this.$route.params.rm;
  }

  get activeUser() {
    return userModule.user;
  }

  get formatedTransferredAt() {
    return this.transferred_at
      ? moment(this.transferred_at.setSeconds(new Date().getSeconds())).format(
          "YYYY-MM-DD HH:mm:ss"
        )
      : null;
  }

  get registerKunjungan() {
    return RegisterKunjungan.register;
  }

  get input() {
    return {
      register_id: this.registerId,
      pasien_rm: this.pasienRm,
      unit_id: this.activeUser.unit_id,
      from_user_id: this.id ? this.from_user_id : this.activeUser.id,
      to_user_id: this.to_user_id,
      transferred_at: this.formatedTransferredAt
    };
  }

  get isVerified() {
    return this.verifiedAt ? true : false;
  }

  async mounted() {
    this.clearInput();
    this.$nextTick(() => {
      // this.sub.focus();
    });
  }

  async save() {
    if (!this.saving) {
      this.saving = true;

      try {
        const isEdit = !!this.id;
        const resp = this.id
          ? await Handover.update(this.id, this.input)
          : await Handover.create(this.input);

        if (!this.id) {
          this.id = resp["id"];
        }

        this.clearInput();
        appModule.sendSuccessNotice(
          isEdit ? "Handover berhasil diubah" : "Handover berhasil disimpan"
        );

        this.getByRegister();
      } finally {
        this.saving = false;
      }
    }
  }

  get isDisabledInput() {
    return false;
  }

  get disabledInputMsg() {
    return null;
  }

  async remove(alasan = null) {
    if (!this.removing) {
      this.removing = true;

      try {
        await Handover.destroy(this.id, alasan?.alasan);

        await this.getByRegister();

        this.clearInput();
      } finally {
        this.removing = false;
      }
    }
  }

  async getByRegister() {
    await CpptRanapStore.getHandoverByRegister(this.registerId);
  }

  removeHandler() {
    const q = confirm("Menghapus Handover ini?");

    if (q) {
      this.remove();
    }
  }

  clearInput() {
    this.id = null;
    this.from_user_id = null;
    this.to_user_id = null;
    this.transferred_at = null;
    this.examinedAt = null;
    this.verifiedAt = null;

    this.$emit("input", null);
  }

  formatDate(date) {
    return date ? moment(date).format("DD-MM-YYYY HH:mm") : null;
  }
}
